var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 285,
    viewBox: "0 0 295 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01855 3C95.1933 3 188.004 7 281.076 7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.76 3.48718C280.76 21.2456 284.025 42.3973 290.077 59.1318C296.933 78.091 291.793 104.093 291.793 123.716C291.793 156.08 294 187.453 294 219.637C294 238.583 294 257.567 294 276.487",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294 276.487C257.53 276.487 220.956 276.145 184.942 271.714C161.903 268.88 140.753 271.843 117.83 271.843C107.169 271.843 97.6247 276.487 87.5357 276.487C77.7096 276.487 67.8835 276.487 58.0574 276.487C42.3279 276.487 26.5984 276.487 10.8689 276.487",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 14.405 1 27.81 1 41.215C1 61.1615 4.38702 79.4656 7.05114 99.172C10.2097 122.536 6.89547 146.466 8.53913 169.943C11.0166 205.329 9.92791 240.569 9.92791 276",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5254 278.481C74.5254 247.428 72 215.792 72 184.654C72 175.276 72.6605 170.145 75.5075 161.503C77.4562 155.588 81.3496 149.043 84.6271 143.566C90.5628 133.646 108.392 123.226 118.72 122.562C134.881 121.523 151.487 122.169 167.685 122.562C179.935 122.859 190.155 133.433 196.447 144.026C201.855 153.129 209.216 166.983 211.88 177.755C215.31 191.62 221 208.407 221 222.982C221 231.363 221 239.744 221 248.125C221 260.083 221 272.042 221 284",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.465 122.897C117.367 122.897 90.2095 105.44 101.31 75.4661C105.58 63.9358 107.755 54.6349 120.369 50.8242C130.101 47.8838 143.37 48.7661 152.636 51.5653C173.272 57.8 184.526 79.8187 184.526 100.386C184.526 115.68 155.422 122.897 143.767 122.897",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.995 68.8825C107.721 62.3434 117.562 59.4839 120.113 54.3835",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.162 78.5484C107.101 73.6089 110.326 67.419 115.433 62.8221C119.019 59.5952 123.668 55.696 127.708 53.0027",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.162 85.4526C102.162 82.4214 106.746 77.109 108.913 74.9428C110.449 73.4067 111.258 71.5644 113.209 70.4167C114.576 69.6124 116.785 67.9353 118.042 66.8112C121.154 64.026 124.216 61.634 127.171 58.6795C129.328 56.5217 132.496 55.8539 133.921 53.0027",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.781 90.976C101.347 85.3184 109.558 80.5582 112.365 75.7867C114.466 72.2141 120.003 68.3159 123.22 65.8139C129.278 61.102 135.516 55.6575 142.206 52.3123",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.781 94.4281C105.524 89.685 110.563 85.3363 115.28 80.6197C119.267 76.6331 122.355 70.3408 127.324 67.5016C129.014 66.5359 130.554 65.0094 132.234 64.0495C133.894 63.1007 134.431 61.0929 136.299 60.559C137.128 60.3223 140.309 58.1359 140.826 57.4905C141.864 56.1928 144.27 55.3092 145.659 54.3835",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.162 97.8803C103.184 97.7525 104.438 95.4848 105.307 94.7734C106.913 93.4594 108.561 92.8617 110.102 91.3212C112.217 89.2056 114.716 88.2293 116.661 85.7978C119.409 82.3628 123.065 77.6092 127.017 75.6333C131.879 73.2023 134.276 66.784 139.061 64.0495C141.359 62.7363 142.669 59.8967 144.968 58.6795C146.898 57.6576 148.579 56.0303 150.492 55.074",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.543 102.023C108.301 97.2646 113.069 92.8802 117.888 88.0609C122.557 83.3921 126.885 77.5535 132.541 74.5593C136.81 72.2988 141.057 68.2828 144.815 65.2769C146.752 63.727 149.259 63.2402 151.029 61.8248C152.804 60.4041 154.766 58.8055 156.705 57.8357",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.924 104.785C105.283 101.55 110.02 99.9382 112.173 98.2639C115.1 95.9871 118.788 94.2294 121.494 91.6665C126.143 87.2618 130.261 83.0583 134.458 78.395C136.608 76.0066 138.617 73.2472 141.171 71.2606C142.993 69.843 146.157 66.387 148.42 66.1208C149.507 65.9929 153.209 63.242 153.944 62.3235C155.196 60.7576 158.32 59.1385 160.158 58.5261",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.995 105.475C108.374 105.302 112.736 101.059 113.899 99.9515C115.365 98.5549 116.657 97.1929 118.041 95.8089C119.565 94.2852 121.761 91.8836 123.565 90.8225C128.802 87.7418 134.106 82.5063 138.409 78.2031C142.342 74.27 148.022 72.2384 152.217 68.8824C155.613 66.1657 159.546 61.2877 164.3 61.2877",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.066 108.927C109.303 106.789 114.382 103.106 116.277 102.023C119.225 100.338 121.732 97.0394 124.946 95.2719C130.604 92.1596 134.235 85.7946 140.135 82.8443C145.645 80.0892 149.863 75.3412 154.097 71.1071C155.73 69.4738 157.982 68.5694 159.85 67.5016C161.96 66.2963 163.538 64.4302 165.681 63.359",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.518 108.927C114.565 108.671 116.635 104.81 118.041 103.404C120.697 100.748 123.889 97.3524 127.362 95.809C134.094 92.8169 139.642 86.4278 145.236 81.6936C152.241 75.7665 159.793 69.4096 167.752 65.4303",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.899 113.07C114.143 110.873 119.327 108.476 120.957 107.009C122.703 105.438 125.425 103.152 127.401 102.023C130.267 100.385 132.549 96.4402 135.456 94.4281C138.558 92.2804 141.671 90.1268 144.623 87.8307C149.23 84.2474 154.601 81.036 158.623 77.0141C160.55 75.0876 164.038 74.0433 165.681 71.9893C166.707 70.706 169.72 68.2439 171.204 67.5016",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.042 113.76C124.239 107.562 131.936 103.279 139.445 99.1076C143.955 96.6015 147.667 92.0356 151.335 88.3676C154.929 84.7742 157.799 80.5998 161.385 77.014C164.785 73.6141 169.277 72.2623 173.275 70.2632",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.494 115.141C123.622 114.904 126.977 111.375 128.743 110.001C131.126 108.148 135.777 107.271 137.373 104.478C138.114 103.181 140.426 102.422 141.516 101.332C142.796 100.052 144.338 98.6204 146.004 97.8802C148.903 96.5917 151.243 94.2412 153.598 92.3568C157.566 89.1831 160.358 84.99 164.99 82.5374C167.012 81.4673 169.074 80.2946 170.667 78.7017C172.183 77.1855 173.823 75.0962 176.037 75.0962",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.327 117.212C134.986 108.553 147.71 104.982 155.324 95.4637C158.351 91.6805 164.702 90.5985 168.289 87.3704C171.473 84.5048 175.764 81.7917 179.489 79.9292",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.541 119.283C136.52 115.304 142.479 113.047 147.001 109.656C151.414 106.346 156.227 103.66 160.503 100.335C163.896 97.6961 167.978 95.9663 171.051 92.8939C173.734 90.2109 176.853 86.1431 180.87 86.1431",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.683 121.355C138.153 121.191 140.631 118.537 142.206 117.749C144.468 116.618 145.99 114.573 148.075 113.415C151.918 111.28 154.92 107.771 158.777 105.628C160.425 104.713 162.951 103.222 164.3 102.023C166.485 100.08 170.476 99.9895 172.547 97.5733C173.918 95.9742 178.812 91.6664 180.87 91.6664",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.492 119.974C150.932 116.007 157.39 114.631 159.467 112.034C161.489 109.506 165.566 108.553 167.752 105.82C169.076 104.165 173.984 100.899 176.037 100.642C178.767 100.301 180.688 96.9356 182.942 95.809",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.467 119.283C159.699 117.426 165.894 114.927 167.407 113.415C168.869 111.953 170.65 110.889 172.24 109.617C174.841 107.537 178.657 104.855 181.561 103.404",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84 157C85.3293 144.823 103.334 139.498 108 130",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76 175C84.8945 165.719 90.7005 154.088 99.8979 145.45C106.354 139.387 114.725 132.061 122 127",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76 187C76 181.395 84.2282 171.573 88.1159 167.567C90.873 164.727 92.3244 161.321 95.8261 159.199C98.28 157.711 102.245 154.611 104.5 152.532C110.087 147.382 115.581 142.959 120.884 137.496C124.757 133.507 130.441 132.272 133 127",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73 198C74.0243 187.464 88.8906 178.6 93.9722 169.714C97.777 163.061 107.801 155.802 113.625 151.143C124.593 142.368 135.887 132.23 148 126",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73 204C81.561 195.235 90.656 187.199 99.1692 178.483C106.365 171.116 111.94 159.488 120.908 154.241C123.958 152.457 126.737 149.636 129.769 147.862C132.766 146.109 133.735 142.399 137.108 141.412C138.603 140.974 144.345 136.934 145.277 135.741C147.151 133.343 151.494 131.711 154 130",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76 210C77.8406 209.764 80.0967 205.579 81.6619 204.266C84.5529 201.841 87.5199 200.738 90.2929 197.895C94.1012 193.991 98.5984 192.189 102.1 187.702C107.047 181.362 113.629 172.589 120.743 168.943C129.495 164.456 133.809 152.611 142.424 147.565C146.561 145.141 148.918 139.901 153.057 137.654C156.532 135.768 159.557 132.765 163 131",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78 218C86.5923 209.17 95.2021 201.034 103.905 192.09C112.336 183.426 120.151 172.591 130.364 167.035C138.074 162.84 145.743 155.387 152.528 149.809C156.027 146.933 160.554 146.029 163.749 143.403C166.956 140.766 170.498 137.8 174 136",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M81 223C81.6508 217.056 90.2276 214.095 94.125 211.018C99.4248 206.835 106.102 203.605 111 198.896C119.418 190.802 126.874 183.078 134.472 174.509C138.364 170.12 142.001 165.05 146.625 161.4C149.925 158.795 155.653 152.444 159.75 151.955C161.717 151.72 168.42 146.665 169.75 144.978C172.018 142.1 177.674 139.125 181 138",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84 225C86.5042 224.68 94.4189 216.806 96.5301 214.75C99.1915 212.158 101.537 209.631 104.048 207.062C106.814 204.235 110.799 199.778 114.072 197.809C123.577 192.092 133.202 182.376 141.012 174.391C148.15 167.092 158.459 163.322 166.072 157.094C172.235 152.052 179.373 143 188 143",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76 244C76.4698 239.403 86.5168 231.48 90.2656 229.152C96.097 225.529 101.057 218.434 107.415 214.633C118.609 207.94 125.791 194.251 137.463 187.906C148.364 181.981 156.708 171.769 165.084 162.663C168.315 159.151 172.769 157.206 176.466 154.909C180.639 152.317 183.762 148.304 188 146",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73 257C77.3722 256.377 81.7952 246.967 84.8 243.54C90.4737 237.068 97.2935 228.793 104.713 225.032C119.095 217.74 130.946 202.17 142.899 190.633C157.863 176.189 173.997 160.697 191 151",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76 265C76.5238 259.698 87.6511 253.911 91.1486 250.37C94.8967 246.577 100.74 241.058 104.98 238.333C111.132 234.38 116.031 224.857 122.269 220C128.928 214.816 135.609 209.617 141.946 204.074C151.835 195.424 163.363 187.672 171.996 177.963C176.131 173.312 183.618 170.792 187.145 165.833C189.348 162.735 195.814 156.792 199 155",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93 254C105.231 240.748 120.42 231.591 135.238 222.672C144.139 217.314 151.464 207.551 158.703 199.709C165.794 192.026 171.458 183.101 178.535 175.434C185.244 168.165 194.11 165.274 202 161",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76 273C81.1498 272.398 89.2694 263.408 93.5443 259.908C99.3113 255.187 110.567 252.955 114.43 245.839C116.223 242.537 121.818 240.604 124.456 237.828C127.554 234.566 131.286 230.92 135.316 229.034C142.332 225.753 147.996 219.765 153.696 214.966C163.297 206.882 170.054 196.201 181.266 189.954C186.158 187.228 191.149 184.241 195.004 180.184C198.674 176.322 202.641 171 208 171",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86 276C107.011 254.169 137.887 245.164 156.364 221.167C163.708 211.628 179.119 208.9 187.823 200.761C195.549 193.536 205.961 186.696 215 182",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M123 265C130.822 256.595 142.537 251.827 151.425 244.664C160.099 237.673 169.561 232 177.964 224.977C184.634 219.403 192.659 215.749 198.698 209.259C203.972 203.592 210.103 195 218 195",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130 270C132.927 269.653 137.862 264.021 141 262.349C145.505 259.949 148.535 255.61 152.688 253.151C160.34 248.621 166.32 241.174 174 236.628C177.282 234.685 182.313 231.522 185 228.977C189.352 224.855 197.299 224.662 201.424 219.535C204.153 216.141 213.9 207 218 207",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M158 267C158.869 258.627 171.605 255.723 175.702 250.243C179.691 244.908 187.73 242.897 192.043 237.129C194.654 233.636 204.333 226.742 208.383 226.2C213.767 225.48 217.556 218.378 222 216",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M175 265C175.462 261.14 187.8 255.947 190.813 252.804C193.724 249.767 197.272 247.556 200.437 244.913C205.618 240.589 213.218 235.017 219 232",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181 274C181.462 270.14 193.8 264.947 196.813 261.804C199.724 258.767 203.272 256.556 206.437 253.913C211.618 249.589 219.218 244.017 225 241",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.8fac91bbee090e09130d49a26a8b2c18.svg";
export { ForwardRef as ReactComponent };